// components/misc/Workflow/TriggerNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const RestApiNode = React.forwardRef(({ data, isConnectable }, ref) => {
    const handleStyle = {
        backgroundColor: "black",
        width: "2px",
        height: "2px",
        borderRadius: "50%",
        border: "1px solid #ccc", // Added border for better visibility
        // boxShadow: "0 0 2px rgba(0,0,0,0.2)", // Added box shadow for better visibility
        cursor: "pointer", // Added cursor style
    };

    const bottomHandleStyle = {
        ...handleStyle,
        transform: "translateY(20px) translateX(-50%)"
    };

    const handleOnClick = (event) => {
        if (data.onClick) {
            data.onClick(event, data.id);
        }
    }

    const addBtnStyle = {
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #0000FF",
        backgroundColor: "#fff",
        color: "#0000FF",
        fontSize: "10px",
        lineHeight: "1",
    };

    const onAddNextActionClick = (event) => {

        //console.log(event);
        // event.stopPropagation(); // Prevent the click from propagating to the node
        if (data.onAddNextActionClick) {
            data.onAddNextActionClick(event, data.id, data.parentId, 60);
        }
    }

    return (
        <div className="flex flex-col items-center justify-center"
            style={{
                // position: "relative",
                background: "transparent",
                zIndex: 10,
                width: data && data.style && data.style.width ? data.style.width : "100%", // Default to 100% if no width is provided
                height: data && data.style && data.style.height ? data.style.height : "100%", // Default to 100% if no height is provided
                // paddingBottom: "50px", // Ensure there's space for the add button
            }}>
            <div onClick={handleOnClick} ref={ref} className="relative w-[140px] rounded-md border border-gray-800 bg-white p-1 text-center text-gray-900">
                {data && data.invokeAfter && data.invokeAfter.length > 0 && (
                    <Handle
                        type="target"
                        position={Position.Top}
                        id="b"
                        isConnectable={isConnectable}
                        style={handleStyle}
                    />
                )}
                <Handle
                    type="source"
                    position={Position.Bottom} // Changed to bottom
                    id="b"
                    isConnectable={isConnectable}
                    style={bottomHandleStyle}
                />
                <div title={data.label} className="overflow-hidden text-ellipsis whitespace-nowrap text-[0.5rem]">{data.label}</div>
            </div>
            <div onClick={onAddNextActionClick} style={addBtnStyle}>+</div>
        </div>
    );
});

export default RestApiNode;
